/**
 * @file: AnnotationTagOption.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { AbnormalLevel, SeverityLevel } from '@euler/model/enum';
import * as Metadata from './AnnotationMetadata';

/**
 * An inspection result option a tag can stand for, e.g. `凹陷` / `损伤`.
 * The levels it carries decide the tag color and, in turn, the defective
 * level the annotated image contributes to the inspected item.
 */
export type AnnotationTagOption = {
  /** id of the check item option this tag stands for */
  id: number;
  label: string;
  abnormalLevel: AbnormalLevel;
  severityLevel: SeverityLevel;
};

export const annotationTagOptionToMetadata = (
  option: AnnotationTagOption,
): Metadata.TagOption => ({
  id: option.id,
  label: option.label,
  abnormal_level: option.abnormalLevel,
  severity_level: option.severityLevel,
});

export const annotationTagOptionFromMetadata = (
  option: Metadata.TagOption,
): AnnotationTagOption => ({
  id: option.id,
  label: option.label,
  abnormalLevel: option.abnormal_level,
  severityLevel: option.severity_level,
});
